import * as moment from "moment";
import { IWorkflowNode } from "../Entity/IWorkflowNode";
import { ECustomSorter } from "../Enums/ECustomSorter";

export function SortVisibleNodes(
    nodes: IWorkflowNode[] = [],
    customSorter: ECustomSorter | undefined
) {
    if (customSorter === undefined) {
        return [...nodes].sort(defaultSorter);
    }

    if (customSorter === ECustomSorter.ByEntryDate) {
        return [...nodes].sort((a, b) => {
            const valueA = a.name.split(`\n`)[0];
            const valueB = b.name.split(`\n`)[0];
            const result = +valueA - +valueB;
            return result;
        });
    }

    if (customSorter === ECustomSorter.ByStartingNumber) {
        return [...nodes].sort((a, b) => {
            const valueA = Number.parseInt(a.name.split(` `)[0]);
            const valueB = Number.parseInt(b.name.split(` `)[0]);
            const result = +valueA - +valueB;
            return result;
        });
    }

    return nodes;
}

const defaultSorter = (a: IWorkflowNode, b: IWorkflowNode) =>
    moment(a.lastmodifiedtime).diff(moment(b.lastmodifiedtime));
